<template>
  <v-container>
    <v-card class="mb-5">
      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th class="text-left">{{$t('DeviceTypes.name')}}</th>
              <th class="text-left">{{$t('DeviceTypes.trigger')}}</th>
              <th>
                <v-btn icon @click="createAlert()">
                  <v-icon>add</v-icon>
                </v-btn>
              </th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(alert,index) in alerts" :key="index">
              <td>{{ alert.name }}</td>
              <td>{{ alert.fields }}</td>
              <td>
                <v-btn icon :id="index" @click="updateAlert($event)">
                  <v-icon :id="index">settings</v-icon>
                </v-btn>
              </td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
    </v-card>
    <v-row>
      <v-col class="text-center">
        <v-btn class="ma-2" tile outlined color="primary" @click="$emit('back')">
          <v-icon left>mdi-arrow-left</v-icon>
          {{$t('DeviceTypes.back')}}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
  <!-- Or manually control the data synchronization -->
</template>

<script>
import axios from "axios";
import tokenStore from "../../store/TokenStore";

export default {
  props: {
    path: String,
    choosenDeviceType: Object
  },
  components: {},
  data() {
    return {
      alerts: []
    };
  },
  methods: {
    createAlert: function() {
      this.$emit("createAlert");
    },
    updateAlert: function(event) {
      if (event.target.id != "") {
        this.$emit("updateAlert", this.alerts[event.target.id]);
      }
    }
  },
  beforeMount: function() {
    axios
      .get(
        process.env.VUE_APP_API_ADDR +
          "/api/devicetype/" +
          this.choosenDeviceType.deviceTypeId +
          "/alert",
        {
          headers: { Authorization: tokenStore.getToken() }
        }
      )
      .then(res => {
        if (res.data.success) {
          this.alerts = res.data.deviceType.alerts;
          this.alerts.forEach(alert => {
            alert.fields = [];
            Object.keys(alert.testJson).forEach(field => {
              alert.fields.push(field);
            });
          });
        }
      })
      .catch(() => {
        this.alertType = "error";
        this.alertMsg = this.$t("DeviceTypes.Alert.error");
        this.alert = true;
      });
  },
  mounted() {
    //console.log("the current CodeMirror instance object:", this.codemirror);
    // you can use this.codemirror to do something...
    //console.log("the current CodeMirror instance object:", this.codemirrorend);
    // you can use this.codemirror to do something...
  }
};
</script>





